import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

const required = () => i18n.t('general.validations.fieldIsRequired');

export const VehicleReassignBulkFormSchema = z
  .object({
    ownerUserId: z.string().uuid().nullable(),
    assigneeIds: z.array(z.string().uuid()),
    assigneeMode: z.enum(['REPLACE', 'ADD', 'REMOVE']).nullable(),
  })
  .superRefine((values, context) => {
    if (
      isNil(values.assigneeMode) &&
      (values.assigneeIds.length > 0 || isNil(values.ownerUserId))
    ) {
      context.addIssue({code: z.ZodIssueCode.custom, path: ['assigneeMode'], message: required()});
    }
    if (
      !isNil(values.assigneeMode) &&
      values.assigneeMode !== 'REPLACE' &&
      values.assigneeIds.length === 0
    ) {
      context.addIssue({code: z.ZodIssueCode.custom, path: ['assigneeIds'], message: required()});
    }
  });
